import type { IntlShape } from 'react-intl';

import { aiSuggestionsMessages } from '@atlaskit/editor-common/ai-messages';

/**
 * Returns the domain-specific rotating messages shown while the AI
 * suggestions thinking bar is active.
 */
export function getThinkingRotatingMessages(formatMessage: IntlShape['formatMessage']): string[] {
	return [
		formatMessage(aiSuggestionsMessages.thinkingReviewingContent),
		formatMessage(aiSuggestionsMessages.thinkingCheckingRelatedSources),
		formatMessage(aiSuggestionsMessages.thinkingIdentifyingImprovements),
		formatMessage(aiSuggestionsMessages.thinkingPreparingSuggestions),
	];
}
